import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type { GetFilterIdListResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  shortErrorMessage?: string
  children?: (data: GetFilterIdListResponse[]) => ReactElement
}

const GetModelerTestCaseNamesRequest = ({
  shortErrorMessage,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/test_case_names`

  const { requestParams } = useGetParamsWithSpaceId({})

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetModelerTestCaseNamesRequest
